export const environment = {
  production: false,
  plutoPay: false,
  dataServiceUrl: 'https://api-parkright-daniel.parkdigify.se/api'
}
